import { Component } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RegistryItem } from 'src/app/api/models';
import { RegistryTypeEnum } from '../enums/registry_type_enum.enum';
import { ModalRegPickerComponent } from '../modal-reg-picker/modal-reg-picker.component';

@Component({
  selector: 'app-modal-confirm-delivery-address',
  templateUrl: './modal-confirm-delivery-address.component.html',
  styleUrls: ['./modal-confirm-delivery-address.component.scss'],
})
export class ModalConfirmDeliveryAddressComponent {
  question_title?: string;
  currentAddressLabel: string;
  // mostra il pulsante che, invece di creare la consegna, avvia un trasferimento tra magazzini
  allowTransfer: boolean;

  selectedRegistry?: RegistryItem;
  registryPickerRef?: DynamicDialogRef;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.question_title = config.data?.question_title;
    this.currentAddressLabel = config.data?.currentAddressLabel ?? '';
    this.allowTransfer = config.data?.allowTransfer ?? false;
  }

  openRegistryPicker() {
    this.registryPickerRef = this.dialogService.open(ModalRegPickerComponent, {
      header: 'Seleziona azienda di destinazione',
      width: '70%',
      data: {
        question_title: 'Seleziona una nuova azienda di destinazione',
        pickerType: 'radio',
        contactTypes: [RegistryTypeEnum.FORNITORE],
        selectedRegistry: this.selectedRegistry,
      },
    });
    this.registryPickerRef.onClose.subscribe((r: { value: RegistryItem | null }) => {
      if (r?.value) {
        this.selectedRegistry = r.value;
      }
    });
  }

  resetToDefault() {
    this.selectedRegistry = undefined;
  }

  close() {
    this.ref.close();
  }

  transfer() {
    this.ref.close({ transfer: true });
  }

  confirm() {
    this.ref.close({
      override_registry_end_customer_id: this.selectedRegistry?.id,
    });
  }
}
